
import React from 'react';
import { format } from 'date-fns';
import { pl, enUS } from 'date-fns/locale';
import { useLanguage } from '@/hooks/useLanguage';
import { RansomwareItem } from '@/types/dashboard';
import { Badge } from '@/components/ui/badge';

interface RansomwareListItemProps {
  attack: RansomwareItem;
}

export function RansomwareListItem({ attack }: RansomwareListItemProps) {
  const { language } = useLanguage();
  
  const formatDate = (dateString: string) => {
    try {
      const date = new Date(dateString);
      return format(date, 'dd MMM yyyy', {
        locale: language === 'pl' ? pl : enUS,
      });
    } catch (error) {
      console.error("Date formatting error:", error, "for date:", dateString);
      return dateString;
    }
  };

  // Safely display data with fallbacks
  const victim = attack?.victim || 'Unknown victim';
  const group = attack?.group || 'Unknown group';
  const domain = attack?.domain || '';
  const attackDate = attack?.attackdate || '';

  return (
    <div className="group">
      <div className="flex flex-col">
        <div className="flex justify-between items-start">
          <span className="font-medium line-clamp-1">{victim}</span>
          <Badge variant="outline" className="ml-2 text-xs">
            {group}
          </Badge>
        </div>
        <div className="flex justify-between text-xs text-muted-foreground mt-1">
          <span className="line-clamp-1">{domain}</span>
          <span className="ml-2 whitespace-nowrap">
            {attackDate ? formatDate(attackDate) : ''}
          </span>
        </div>
      </div>
    </div>
  );
}
